/**
 * Created by c_razmuss_a on 25/01/2018.
 */
'use strict';

/**
 * Asserts if provided val exists, throws error with msg if it doesn't
 * @param val value to be checked for "truthy" if (val)
 * @param msg message to be included in the error
 */
function assertExists(val, msg) {
    if (val) {
        return;
    } else {
        throw new Error(msg);
    }
}

/**
 * Asserts if provided val is of type, throws error with msg if type is incorrect
 * @param val value to be checke for type
 * @param type expected type
 * @param msg message to be included in the error if type doesn't match
 */
function assertType(val, type, msg){
    if (typeof val !== type) {
        throw new Error(msg);
    }
}

module.exports.assertExists = assertExists;
module.exports.assertType = assertType;




//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/utils/asserts.js
// module id = VgQt
// module chunks = 0 1 2 3 4